import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const Container = styled.div`
  /* max-width: 900px; */
  /* position: relative; */
  margin: 2em clamp(0.1em, 8vw, 300px);

  @media (max-width: 576px) {
    margin: 0 0.8em;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  width: 100%;
  max-width: 900px;
  margin: 2em auto;
  position: relative;
  overflow: visible;

  background-color: #caa0371f;
  border: 0.5px solid #5c0630;
  border-radius: 16px;

  @media (max-width: 576px) {
    padding: 1rem;
  }
`;

export const Title = styled.h1`
  font-size: 2rem;
  color: #344b45;
  text-align: center;
  margin-bottom: 1rem;
  padding-top: 2em;
  span {
    display: block;
    font-size: 16px;
    padding: 1em;
  }
`;

export const H3 = styled.h3`
  font-size: clamp(22px, 2.2vw, 10em);
  font-weight: bold;
  color: #273743;
  text-align: center;
  padding-top: 1em;
`;

export const Description = styled.p`
  font-size: 1rem;
  color: #4a5d58;
  text-align: center;
  line-height: 1.5;
  padding-bottom: 1em;
`;

export const ShapeTopLeft = styled.div`
  position: absolute;
  /* background-color: #c39442; */
  border-radius: 8px;
  top: -3em;
  left: ${(props) => props.lang === "en" ? "0" : "70px"};
  right: ${(props) => props.lang === "en" ? "0" : "70px"};
  object-fit: contain;

  img {
    width: 150px;
    height: 150px;
  }
  @media (max-width: 768px) {
    left: auto;
  }
`;


export const ShapeBottomRight = styled.div`
  position: absolute;
  img {
    width: 170px;
    height: 170px;
  }
  /* background-color: #c39442; */
  /* border: 0.1px solid black; */
  border-radius: 8px;
  bottom: -4em;
  right: 70px;
  object-fit: contain;
  @media (max-width: 768px) {
    right: auto;
  }
`;

export const Team = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin: 2em auto;
  padding: 2rem;
`;

export const Member = styled.div`
  display: flex;
  flex: 0 1 calc(33% - 20px);

  .papper {
    display: flex;
    flex-direction: column;
    position: relative;
    box-sizing: border-box;
    line-height: 1.4em;

    width: 100%;
    /* height: 100px; */
    background: #ffffff;
    background-image: linear-gradient(#ffffff 1.1rem, #ebebeb 1.2rem);
    background-size: 100% 1.2rem;
    padding-left: 10px;
    font-size: 14px;
    p:first-child {
      font-weight: 900;
    }
    .social {
      /* background-color: red; */
      margin-top: auto;
      /* margin: auto 0; */
      margin-bottom: 8px;
      display: flex;
      flex-direction: row;
      justify-content: end;
      align-items: center;
      height: 24px;
      a {
        display: flex;
      }
      svg {
        /* background-color: green; */
        margin-left: 10px;
        cursor: pointer;
      }
    }
    img {
      background-color: red;
    }
  }

  @media (max-width: 922px) {
    flex: 1 1 calc(50% - 20px);
  }

  @media (max-width: 768px) {
    flex: 1 1 calc(100% - 20px);
  }

  img {
    /* overflow: auto; */
    /* object-fit: cover; */
    width: 100px;
    height: 100px;
    padding: 0px;
    border-radius: 100%;
  }

  p {
    width: 100%;
    /* text-align: right; */
    &:first-child {
      /* text-align: left; */
    }
    /* font-weight: 900; */
  }
  /* .papper::before,
  .papper::after {
    position: absolute;
    content: "";
    bottom: 10px;
    width: 40%;
    height: 10px;
    box-shadow: 0 5px 14px rgba(0, 0, 0, 0.7);
    z-index: -1;
    transition: all 0.3s ease;
  } */

  /* .papper::before {
    left: 15px;
    transform: skew(-5deg) rotate(-5deg);
  } */

  /* .papper::after {
    right: 15px;
    transform: skew(5deg) rotate(5deg);
  } */

  /* .papper:hover::before,
  .papper:hover::after {
    box-shadow: 0 2px 14px rgba(0, 0, 0, 0.4);
  } */
`;

export const MenuLink = styled(NavLink)`
  color: ${(props) => props.theme.colors.txt.color1};
  text-decoration: none;
  padding: 0 16px;
  &:hover {
    color: ${(props) => props.theme.colors.txt.color4};
    /* transform: scale(1.05); */
    transition: transform 0.2s;
    /* font-weight: 700; */
  }
  /* font-size: clamp(12px, 1.2vw, 2em);
  color: ${(props) => props.theme.colors.colorbg};
  text-decoration: none;
  margin: 0 15px; */

  /* transition: all .2s  */
`;
